import { useQuery } from '@tanstack/react-query'

import { fetchCourtRemainingWindows } from '@/lib/venue/priceApi'
import type { CourtRemainingWindowsView } from '@/lib/venue/priceTypes'

export function courtRemainingWindowsQueryKey(venueId: string, courtId: number, date: string) {
  return ['venue', venueId, 'courts', courtId, 'remaining-windows', date] as const
}

/**
 * 그 날짜에 **지금 무슨 값이 먹고 있는지**(날짜 > 요일유형 > 기본가) 안내용(#866 API ⑤).
 *
 * 🚨 편집 중 선택지 계산에는 쓰지 않는다 — 서버는 저장되지 않은 편집을 모른다(설계 D6).
 * 날짜를 고른 뒤에만 호출한다(`enabled`).
 */
export function useCourtRemainingWindows(venueId: string, courtId: number, date: string) {
  return useQuery<CourtRemainingWindowsView>({
    queryKey: courtRemainingWindowsQueryKey(venueId, courtId, date),
    queryFn: () => fetchCourtRemainingWindows(venueId, courtId, { date }),
    enabled: Boolean(date),
  })
}
